module.exports = __webpack_public_path__ + "static/media/star.8a8bf40a.svg";